module.exports = __webpack_public_path__ + "media/images/icons/logout-673f62457cf37a512a0864d8fc2a11fa.svg";